// Holds the page still while a full-screen panel is open.
//
// `overflow: hidden` on <body> is the usual trick and iOS Safari ignores it —
// the page keeps touch-scrolling behind the panel. Pinning the body works
// everywhere, at the cost of having to remember and restore the scroll offset.
//
// Counted, because more than one panel can be open across a single close/open
// hand-off and the lock must survive until the last one is gone.
let lockCount = 0
let savedScrollY = 0
let savedPaddingRight = ''

export function lockBodyScroll() {
  if (typeof document === 'undefined') return
  if (++lockCount > 1) return

  const body = document.body
  savedScrollY = window.pageYOffset || document.documentElement.scrollTop || 0

  // Pinning the body takes the scrollbar with it, so pad by the same width to
  // stop the page behind jumping sideways on desktop.
  const scrollbarWidth =
    window.innerWidth - document.documentElement.clientWidth
  savedPaddingRight = body.style.paddingRight
  if (scrollbarWidth > 0) {
    body.style.paddingRight = `${scrollbarWidth}px`
  }

  body.style.top = `-${savedScrollY}px`
  body.classList.add('slide-modal-open')
}

// `restoreScroll: false` for the cases where the page underneath is going away
// anyway — putting the old offset back would only fight the router.
export function unlockBodyScroll({ restoreScroll = true } = {}) {
  if (typeof document === 'undefined') return
  if (lockCount === 0) return
  if (--lockCount > 0) return

  const body = document.body
  body.classList.remove('slide-modal-open')
  body.style.top = ''
  body.style.paddingRight = savedPaddingRight

  if (restoreScroll) {
    window.scrollTo(0, savedScrollY)
  }
}
